import React, { Component } from 'react'
import { withStyles, Card, CardHeader, Avatar, Typography, CardContent, Grid, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, Button } from '@material-ui/core';
import Add from '@material-ui/icons/Add'
import { PostData } from '../api/service';
import Rich from '../Components/AddNew/Rich';
import Snack from '../Components/Snackbar/Snack';
import FileUpload from '../Components/AddNew/FileUpload';
import { Navbar } from 'react-bootstrap';
import ViewAllTable from '../Components/ViewAll/ViewAllTable';
import ViewCollegeGallery from '../Components/ViewAll/ViewCollegeGallery';

const styles = theme => ({
    textField: {
        width: '100%'
    },
    formControl: {
        width: '100%',
        marginTop: theme.spacing.unit * 2
    }
})

class GalleryContainerMain extends Component {

    state = {
        date: '',
        type: 'COLLEGE',
        dept: '',
        title: '',
        upload_info: [],
        dept_code: 'RANGIA',
        open: false,
        message: '',
        isLoading: true,
    }

    __getInitialState() {
        this.setState({
            date: '',
            type: 'COLLEGE',
            dept: '',
            title: '',
            upload_info: [],
            dept_code: 'RANGIA',
        })
    }


    componentDidMount() {
        PostData(`/getcollegegallery`)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    table_data: resp,
                    isLoading: false
                })
            })
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props !== prevProps) {
    //         this.__loadType()
    //     }
    // }



    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
        // console.log(this.state);
    }


    onSetFile = (data) => {
        //console.log(data)
        this.setState({
            upload_info: data
        })
        // console.log(this.state);
    }

    onSubmit = (e) => {
        e.preventDefault();

        let data = {
            ...this.state
        }

        // console.log(data);


        PostData(`/admin/addgallery`, data)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    open: true,
                    message: resp
                })
            }).then(() => {
                this.__getInitialState();
            })


    }

    actionClick = (el) => {
        console.log(el);
        this.props.history.push(`/edit`, el);
    }

    render() {
        let { classes } = this.props;

        let i = <Grid key={0} item lg={4} sm={12}>
            <TextField
                label="Opening Date"
                className={classes.textField}
                type="date"
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                    shrink: true
                }}

                name="opening_date"
                value={this.state.opening_date}
                onChange={this.handleChange}
            />
        </Grid>;

        let j = <Grid key={1} item lg={4} sm={12}>
            <TextField
                label="Closing Date"
                className={classes.textField}
                type="date"
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                    shrink: true
                }}

                name="closing_date"
                value={this.state.closing_date}
                onChange={this.handleChange}
            />
        </Grid>
        return (
            <div>
                {this.state.open ?
                    <Snack
                        open={this.state.open}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                        message={this.state.message}
                    />

                    : null}
                <form onSubmit={this.onSubmit}>
                    <Card>
                        <CardHeader
                            avatar={
                                <Avatar>
                                    <Add />
                                </Avatar>
                            }
                            title={
                                <Typography
                                    variant="h6"
                                >
                                    Add New {this.props.title}
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item lg={4} sm={12}>
                                    <TextField
                                        label="Date"
                                        className={classes.textField}
                                        type="date"
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        required={true}
                                        name="date"
                                        value={this.state.date}
                                        onChange={this.handleChange}
                                    />
                                </Grid>

                                <Grid item lg={8} sm={12}>
                                    <TextField
                                        label="Caption"
                                        className={classes.textField}
                                        type="text"
                                        margin="normal"
                                        variant="outlined"
                                        required={true}
                                        name="title"
                                        value={this.state.title}
                                        onChange={this.handleChange}
                                    />
                                </Grid>

                                <Grid item lg={12} sm={12}>
                                    {this.props.code !== "" && <FileUpload
                                        dp={this.state.upload_info}
                                        apikey={this.props.apikey}
                                        type={this.props.code}
                                        setDp={this.onSetFile.bind(this)}
                                    />}
                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardActions>
                            <Button
                                variant="outlined"
                                color="primary"
                                type="submit"
                            >
                                Submit
            </Button>
                        </CardActions>

                    </Card>
                    {!this.state.isLoading && (
                        <ViewCollegeGallery
                            table_data={this.state.table_data}
                            isLoading={this.state.isLoading}
                            actionClick={this.onEditClick}
                        />
                    )
                    }
                </form>

            </div>
        )
    }
}

export default withStyles(styles)(GalleryContainerMain)